import { z } from "zod";

import { zIsoDate, zNonEmptyString, zPhoneNumber } from "../../util";

const zShared = z.object({
  title_at_company: z.string().optional(),

  given_name: zNonEmptyString,
  family_name: zNonEmptyString,
  date_of_birth: zIsoDate.refine(
    (d) => d <= new Date().toISOString().substring(0, 10),
    "Date cannot be in the future",
  ),
  country_of_citizenship: zNonEmptyString,
  is_control_person: z.boolean(),
  controlling_firms: z.string().optional(),
  is_affiliated_exchange_or_finra: z.boolean(),
  affiliated_firm: z.string().optional(),

  tax_id_type: zNonEmptyString,
  tax_id: z.string().optional(),
  country_of_tax_residence: zNonEmptyString,
  street_address: zNonEmptyString,
  city: zNonEmptyString,
  state: zNonEmptyString,
  postal_code: zNonEmptyString,
  unit: z.string().optional(),

  is_politically_exposed: z.boolean(),
  immediate_family_exposed: z.boolean(),

  middle_name: z.string().optional(),
});

export const zAuthorizedIndividual = z
  .object({
    is_authorized_individual: z.literal(true),
    email: z.string().email(),
    phone_number: zPhoneNumber,
  })
  .merge(zShared);

export type AuthorizedIndividual = z.infer<typeof zAuthorizedIndividual>;

const zPercentageOwnership = z.coerce.number().min(10).max(100);

export const zUltimateBeneficialOwner = z
  .object({
    is_ubo: z.literal(true),
    percentage_ownership: zPercentageOwnership,
    email: z.string().email(),
    phone_number: zPhoneNumber.optional().or(z.literal("")),
  })
  .merge(zShared);

export type UltimateBeneficialOwner = z.infer<typeof zUltimateBeneficialOwner>;

export type SharedAuthIndividualsUBOsFields = z.infer<typeof zShared>;

export const zUBOQuickAdd = z.object({
  percentage_ownership: zPercentageOwnership,
});

export type UBOQuickAdd = z.infer<typeof zUBOQuickAdd>;
